// Should match the PortTypes in the backend
export const PORT_CONFIG_OPTIONS = {
  Serial: 'Serial',
  TcpIp: 'TcpIp',
  Mock: 'Mock',
  // Web relay boards only - offered where an editor lists it in allowedTypes
  Http: 'Http'
} as const;

export type PortConfigOption = (typeof PORT_CONFIG_OPTIONS)[keyof typeof PORT_CONFIG_OPTIONS];
